import { useState } from "react";
import { useNavigate, Link  } from "react-router-dom";
import { loginUser, /*logoutUser*/ } from "../../services/authService";
import { validateLogin } from "../../hooks/useFormValidation";
import { getFirebaseError } from "../../utils/firebaseErrors";
import logoTitle from "../../assets/images/Logos/kole-medical-wordmark.svg";
import visibilityOn from "../../assets/images/icons/visibility_60dp_024498_FILL1_wght400_GRAD0_opsz48.png";
import visibilityOff from "../../assets/images/icons/visibility_off_60dp_00000_FILL1_wght400_GRAD0_opsz48.png";
import "../../styles/AuthStyles/Login.css";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase/config";

// Add onSwitch to your props
interface LoginProps {
  onSwitch: () => void;
  className?: string;
}

export default function Login({ onSwitch, className }: LoginProps) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [firebaseError, setFirebaseError] = useState("");
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [showPassword, setShowPassword] = useState(false);

  const [form, setForm] = useState({
    email: "",
    password: ""
  });

  const set = (key: string, value: string) => {
    setForm(prev => ({ ...prev, [key]: value }));
    setErrors(prev => ({ ...prev, [key]: "" }));
  };

  const handleLogin = async () => {
    setFirebaseError("");

    // 1. Validate first
    const validationErrors = validateLogin(form);
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      return;
    }

    // 2. Call Firebase
    /*try {
      setLoading(true);
      await loginUser(form.email, form.password);
      //navigate("/"); // ✅ redirect after login
      navigate("/dashboard"); // ✅ redirect after login
    } catch (error: any) {
      setFirebaseError(getFirebaseError(error.code));
    } finally {
      setLoading(false);
    }*/ 

    

    try {
      setLoading(true);

      // 1. Sign in with Firebase Auth
      const userCredential = await loginUser(form.email, form.password);

      // 2. Fetch their Firestore document
      const userDoc = await getDoc(doc(db, "users", userCredential.uid));
      const userData = userDoc.data();

      // 3. Check account status
      if (userData?.accountStatus === "pending") {
        navigate("/");   // send to homepage, not dashboard
        return;
      }

      if (userData?.accountStatus === "suspended") {
        setFirebaseError("Your account has been suspended. Please contact support.");
        return;
      }

      console.log("User data:", userData); // Debugging line
      console.log("User role:", userData?.role); // Debugging line

      // 4. Route based on role — only active accounts reach here
      if (userData?.role === "admin" || userData?.role === "superadmin") {
        navigate("/dashboard");
      } else {
        navigate("/");
      }

    } catch (error: any) {
      setFirebaseError(getFirebaseError(error.code));
    } finally {
      setLoading(false);
    }
        
      };

  return (
    <section className={`loginContainer ${className || ""}`}>
        {firebaseError && <p className="error-banner">{firebaseError}</p>}

        <div className="logoTitle">
            <img src={logoTitle} alt="Kole Medical" width={190} height={37} />
            <h3>Login</h3>
        </div>

        <input
        placeholder="Email"
        type="email"
        value={form.email}
        onChange={e => set("email", e.target.value)}
        />
        {errors.email && <p className="field-error">{errors.email}</p>}

        <div className="passSection">
          <div className="input-password-wrapper">
            <input
              placeholder="Password"
              type={showPassword ? "text" : "password"}
              value={form.password}
              onChange={e => set("password", e.target.value)}
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPassword(prev => !prev)}
            >
              {showPassword ? (
                <img src={visibilityOff} alt="Hide password" />
              ) : (
                <img src={visibilityOn} alt="Show password" />
              )}
            </button>
          </div>
          <Link to="/forgot-password">Forgot Password?</Link>
          {errors.password && <p className="field-error">{errors.password}</p>}
        </div>
        

        <div className="btnSection">
            <button onClick={handleLogin} disabled={loading}>
                {loading ? "Signing in..." : "Login"}
            </button>
            <button className="switchLink" onClick={onSwitch}>
          Don't have an account? Register
        </button>
        </div>
        
    </section>
  );
}